export default __webpack_public_path__ + "static/media/cad33bbd-bbf2-423b-98c5-51136c054e14.5aa0c1f5.woff";